import { SpectrogramPoint } from '@ledium/types';

import waveLengthRange from '../config/waveLengthRange';

interface LightChannelEntry {
    spectrogram: SpectrogramPoint[];
    intensityPercent: number;
}

interface AggregatedPoint {
    waveLength: number;
    pfd: number;
    irradiance: number;
    targetIrradiance?: number;
    targetPfd?: number;
}

type SpectrogramUnit = 'pfd' | 'irradiance';

const waveLengthSumIntensity = (lightChannels: LightChannelEntry[], waveLength: number, unit: SpectrogramUnit): number =>
    lightChannels
        .map((lightChannel) => {
            const unitValue = lightChannel.spectrogram.find((i) => i.waveLength === waveLength)![unit];
            return (unitValue * lightChannel.intensityPercent) / 100;
        })
        .reduce((a, c) => a + c, 0);

const aggregateSpectrograms = (lightChannels: LightChannelEntry[] = [], lightRecipe: { spectrogram?: SpectrogramPoint[] } | null = null): AggregatedPoint[] => {
    const aggregatedSpectrogram: AggregatedPoint[] = [...Array(waveLengthRange.stepNum).keys()].map((e) => {
        const waveLength = e * waveLengthRange.step + waveLengthRange.min;
        return {
            waveLength,
            pfd: waveLengthSumIntensity(lightChannels, waveLength, 'pfd'),
            irradiance: waveLengthSumIntensity(lightChannels, waveLength, 'irradiance')
        };
    });

    if (lightRecipe?.spectrogram) {
        lightRecipe.spectrogram.forEach((item) => {
            const spectrumIdx = aggregatedSpectrogram.findIndex((e) => e.waveLength === item.waveLength);
            if (spectrumIdx > -1) {
                aggregatedSpectrogram[spectrumIdx].targetIrradiance = item.irradiance;
                aggregatedSpectrogram[spectrumIdx].targetPfd = item.pfd;
            }
        });
    }

    return aggregatedSpectrogram;
};

export default aggregateSpectrograms;
